export const wizardLobQueryParamKey = "pwaLob";

export const LOB_KEYS = {
  HOTEL_V2: "wizard-hotel-pwa-v2",
  HOTEL: "wizard-hotel-pwa",
  FLIGHT: "wizard-flight-pwa",
  PACKAGE: "wizard-package-pwa",
  CAR: "wizard-car-pwa",
  LX: "wizard-lx-pwa",
  EXT_LINK: "wizard-externalLinkTab-pwa",
  CRUISE: "wizard-cruise-pwa",
  VR: "wizard-vr-pwa",
  GT: "wizard-gt-pwa",
  THREEPP: "wizard-thirdPartyPackage-pwa",
};

export const LOB_ICONS_MAP = {
  "wizard-hotel-pwa-v2": "lob_hotels",
  "wizard-flight-pwa": "lob_flights",
  "wizard-package-pwa": "lob_packages",
  "wizard-car-pwa": "lob_cars",
  "wizard-lx-pwa": "lob_activities",
  "wizard-externalLinkTab-pwa": "people",
  "wizard-cruise-pwa": "lob_cruise",
  "wizard-vr-pwa": "lob_vacation_rentals",
  "wizard-gt-pwa": "directions_bus",
  "wizard-thirdPartyPackage-pwa": "lob_all_inclusive_vacations",
};
